import { VerticalCarousel } from '@prishapolicy/w3/ui';
import Image from 'next/image';
import { HeroBackground, useWindowWidth } from '@prishapolicy/shared/ui';
import teamImage from './team-photo.png';
import reliable from './icons/reliable.png';
import customerCentric from './icons/customer-centric.png';
import experts from './icons/experts.png';
import indiaMap from './india-map.png';
// import RestartFillIcon from 'remixicon-react/RestartFillIcon';
import Building2FillIcon from 'remixicon-react/Building2FillIcon';
import Building4FillIcon from 'remixicon-react/Building4FillIcon';
// import slugify from 'slugify';
import { slugify } from '@prishapolicy/shared/ui';
import { NextSeo } from 'next-seo';
// import { teamAssets } from '@prishapolicy/shared/assets';
// import teamAssets from 'apps/w3/public/team-assets';
// import * from '../../../public/team-assets';
const stats = [
  {
    title: '1 Lakh+',
    description: 'Satisfied Customers',
  },
  {
    title: '96%',
    description: 'Client Satisfacton Index',
  },
  {
    title: '1500+',
    description: 'Point of Sale Partners',
  },
  {
    title: '200+',
    description: '5-star reviews',
  },
];

const teamMembers = [
  {
    name: 'Sunil Gupta',
    position: 'Managing Director',
  },
  {
    name: 'Ashish Bajpai',
    position: 'Principal Officer',
  },
  {
    name: 'KL Gupta',
    position: 'Director',
  },
  {
    name: 'Neeraj Mantri',
    position: 'Director, Strategy',
  },
  {
    name: 'Gunjan Gulati',
    position: 'Sales & Client Relation',
  },
  {
    name: 'Poonam Hooda',
    position: 'Finance & Accounts',
  },
  {
    name: 'Megha Sharma',
    position: 'Operations',
  },
  {
    name: 'Prateek Gupta',
    position: 'Marketing',
  },
  {
    name: 'Khushboo Kukreti',
    position: 'People Success',
  }
];
const values = [
  {
    name: 'Reliable',
    text: 'Our team ensures the degree of consistency of a measure and hence makes us able to achieve defined objectives.',
    icon: reliable,
  },
  {
    name: 'Customer Centric',
    text: 'With the help of Our customer focused leadership, we believe in designing the experience to empower the front line.',
    icon: customerCentric,
  },
  {
    name: 'Experts',
    text: 'With 10 years of market experience combined with the expertise of our diverse team ensures proficiency',
    icon: experts,
  },
];
const OurTeam = () => {
  const { isLg } = useWindowWidth();

  return (
    <>
      <NextSeo
        description="PrishaPolicy :  Our philosophy is simple — to have a team of that is committed to your risks"
        title="Who we are | PrishaPolicy"
      />
      <div className="container">
        <div className="flex flex-col items-center text-center lg:block">
          <div className="">
            <h6 className="text-primary heading-6">Meet our team</h6>
            <h2 className="heading-3">A team of spearheads and mortars</h2>
            <p className="text-grey-700">
              Our philosophy is simple — to have a team of that is committed to mitigate your risks
            </p>
          </div>
        </div>
        <div className="lg:px-18 mt-6 grid grid-cols-2 gap-x-4 gap-y-14 px-5 lg:grid-cols-3 lg:gap-8">
          {teamMembers.map((member, idx) => {
            return (
              <div key={idx} className=" col-span-1 grid lg:block lg:grid-rows-4">
                <Image
                  src={`/team-assets/${slugify(member.name)}.png`}
                  alt={member.name}
                  width={isLg ? 300 : 171}
                  height={isLg ? 380 : 213}
                />
                <div className="row-span-1">
                  <h4 className="heading-6 lg:heading-4 mt-3">{member.name}</h4>
                  <p className="text-body-1 lg:text-title-6">{member.position}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const Values = () => {
  return (
    <div className="bg-surface-grey my-15 py-16 px-4">
      <div className="container">
        <h3 className="heading-3 text-center">A simple set of values which inspire us in what we do.</h3>
        <div className="grid-cols-3 gap-x-20 lg:grid ">
          {values.map((value, idx) => {
            return (
              <div key={idx} className="mt-16 flex flex-col items-center gap-y-4 text-center">
                <Image src={value.icon} alt={value.name} width={150} height={150} />
                <h5 className="heading-5">{value.name}</h5>
                <p>{value.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const locations = [
  {
    heading: 'Gurgaon (Headquarters)',
    text: '307,308,309, Spaze Platinum Tower, Badshahpur Sohna Rd Hwy, Gurugram, Haryana 122018',
    icon: Building2FillIcon,
    url: 'https://g.page/Prishapolicy',
  },
  {
    heading: 'Kanpur',
    text: '13/392 C-2, Kashi Dham Apartment, Ground Floor,14-Bunglow Colony Sikka Chauraha, Civil Lines Kanpur - 208001',
    icon: Building4FillIcon,
    url: 'https://goo.gl/maps/PFWfo2GhqNfM2ET28',
  },
  {
    heading: 'Jaipur',
    text: '711 A, Corps Arcade Tower, Malviya Marg, C Scheme, Jaipur, Rajasthan 302001',
    icon: Building4FillIcon,
    url: 'https://goo.gl/maps/qwfpx6ow4HJ1PzGX9',
  },
  {
    heading: 'Mumbai',
    text: '1210, Hubtown Viva, Shankarwadi, Western Exp. Way, Jogeshwari East, Mumbai – 400060',
    icon: Building4FillIcon,
    url: 'https://goo.gl/maps/FXxeWGzRCEcpE4P57',
  },
  {
    heading: 'Agra',
    text: '307,308,309, Spaze Platinum Tower, Badshahpur Sohna Rd Hwy, Gurugram, Haryana 122018',
    icon: Building4FillIcon,
    url: 'https://g.page/Prishapolicy',
  },
];
const Locations = () => {
  return (
    <div className="mb-16">
      <h1 className="heading-1 mb-6 text-center">Our Presence</h1>
      <div className="container grid-cols-2 px-4 lg:grid">
        <div className="hidden place-content-center lg:grid">
          <Image src={indiaMap} alt="locations" />
        </div>
        <div>
          <VerticalCarousel carouselItems={locations} mapPin={true} />
        </div>
      </div>
    </div>
  );
};
const About = () => {
  return (
    <>
      <NextSeo description="About Us - Making Insurance Accessible to All" />
      <HeroBackground backgroundColor="blue-300">
        <div className="mx-auto text-center lg:w-3/4">
          <h5 className="lg:heading-5 text-title-5 font-medium">About Us</h5>
          <h1 style={{ fontSize: 40 }} className="mb-4 font-bold">
            Making insurance Accessible to All
          </h1>
          <h6 className="lg:heading-6 text-title-6 ">
            We listen, we pay attention and we meet the expectation. We stand out of the crowd because we maintain an
            outstanding porfolio and we believe in efficiently delivering with remarkable profile.
          </h6>
        </div>
      </HeroBackground>
      <div className="my-15 container flex grid-cols-7 flex-col gap-y-5 gap-x-10 px-4 lg:grid">
        <div className="col-span-4 mb-9">
          <Image className="rounded-large" src={teamImage} alt="team" />
        </div>
        <div className="col-span-3 flex h-fit flex-col justify-between">
          <div>
            <h6 className="heading-6 text-primary">We&apos;ve already helped hundreds of companies</h6>
            <h2 className="heading-2">We&apos;re only just getting started on our journey</h2>
          </div>
          <div className="mt-24 grid grid-cols-2 ">
            {stats.map((stat, idx) => {
              return (
                <div key={idx} className="mt-5">
                  <h2 className="text-title-3 lg:text-title-1 text-primary font-black">{stat.title}</h2>
                  <p className="text-title-7 font-medium">{stat.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="bg-surface-grey">
        <div className="my-15 container py-12 px-4 text-center">
          <h6 className="text-primary heading-6 uppercase">For us, you matter</h6>
          <p className="mt-6">
            Prisha Insurance Brokers Private Limited is promoted by team of professionals and engaged in the business of providing whole range of Insurance consultancy to corporate clients as well as individuals. We assist clients to quantify and oversee risk and guide them to unlock new and unique opportunities for growth. We
            reach out to clientele at all levels to define, design and deliver innovative and imaginative solutions to manage risks to the core.
          </p>
        </div>
      </div>
      <OurTeam />
      <Values />
      <Locations />
    </>
  );
};

export default About;
